import styled from 'styled-components';

const Container = styled.div<{
  subsection?: boolean;
}>`
  display: ${({ subsection }) => (subsection ? 'flex' : 'block')};
  flex-direction: column;
  gap: 16px;
  padding: 16px 0 24px 0;
  align-items: start;

  > div {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 8px;

    h1 {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      color: #161d1f;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
    }
  }
`;

export default Container;
